.gc{padding:0.25rem 0.5rem;}